import { createStore } from 'vuex'
import Setting from './settings'
import Auth from './auth'
import Modal from './modal'
import Calendar from './calendar'
import Meeting from './meeting'

export default createStore({
  modules: {
    Setting,
    Auth,
    Modal,
    Calendar,
    Meeting
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  }
})
